//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CollectEditDialog from '@/components/collect/CollectEidtDialog.vue';
import CollectDelDialog from '@/components/collect/CollectDelDialog.vue';
export default {
  data: function data() {
    return {
      pageNum: 1,
      pageSize: 10,
      collectList: [],
      ifShowEditDialog: false,
      editCollect: {
        favoriteDesc: null,
        favoriteName: null,
        id: null
      },
      ifShowDelDialog: false,
      ifEditCollect: false,
      title: '新建收藏夹',
      delFavoritesId: null,
      total: 0
    };
  },
  components: {
    CollectEditDialog: CollectEditDialog,
    CollectDelDialog: CollectDelDialog
  },
  created: function created() {
    this.getFavoriteList();
  },
  methods: {
    currentChange: function currentChange(val) {
      this.pageNum = val;
      this.getFavoriteList();
    },
    sizeChange: function sizeChange(val) {
      this.pageSize = val;
      this.getFavoriteList();
    },
    toItem: function toItem(item) {
      this.$router.push({
        path: '/system/collectDetail',
        query: {
          id: item.id
        }
      });
    },
    getFavoriteList: function getFavoriteList() {
      var _this = this;
      this.$API.postRequest({
        url: '/platform/favorite/list',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.collectList = res.result.records;
          _this.total = res.result.total;
        }
      });
    },
    createCollect: function createCollect() {
      this.title = '新建收藏夹';
      this.ifEditCollect = false;
      this.editCollect = {
        favoriteDesc: null,
        favoriteName: null,
        id: null
      };
      this.ifShowEditDialog = true;
    },
    submitCollectFn: function submitCollectFn(obj) {
      this.ifShowEditDialog = false;
      if (obj.bool) {
        // 编辑 新增
        this.pageNum = 1;
        this.getFavoriteList();
      } else {
        // 取消
      }
    },
    editCollectDialog: function editCollectDialog(item) {
      this.title = '编辑收藏夹';
      this.ifShowEditDialog = true;
      this.ifEditCollect = true;
      this.editCollect.favoriteName = item.favoriteName;
      this.editCollect.favoriteDesc = item.favoriteDesc;
      this.editCollect.id = item.id;
    },
    delCollectFn: function delCollectFn(obj) {
      if (obj.bool) {
        this.ifShowDelDialog = false;
        this.delFavoritesId = null;
        this.pageNum = 1;
        this.getFavoriteList();
      } else {
        this.ifShowDelDialog = false;
        this.delFavoritesId = null;
      }
    },
    delCollect: function delCollect(item) {
      this.ifShowDelDialog = true;
      this.delFavoritesId = item.id;
    }
  }
};